import { render, staticRenderFns } from "./ListaHistoricos.vue?vue&type=template&id=b9105a64"
import script from "./ListaHistoricos.vue?vue&type=script&lang=js"
export * from "./ListaHistoricos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports